import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { PageAppletCapability, type Specs } from '@doxyme/extensions-bridge';
import { useAddCapability } from '@doxyme/extensions-bridge-react';
import { getPublicRuntimeConfig } from '../../../libs/init/getPublicRuntimeConfig';
import { bridge } from '../../../features/extensions/instances';
import { useNavigateToPreviousRoute } from '../../usePreviousRoute';

const { paths } = getPublicRuntimeConfig();

type QueryParamData = Specs.PageApplet.QueryParamData;

/**
 * Hook responsible for providing callbacks required for pageApplet to the Extensions SDK
 */
export function useExtensionsAddPageApplet(): void {
  const router = useRouter();

  const pageApplet = useAddCapability(bridge, () => new PageAppletCapability());

  const navigate = useNavigateToPreviousRoute(paths.dashboard);

  useEffect(() => {
    const unsubscribes = [
      pageApplet.onOpen(
        async (
          manifestId: string,
          name?: string,
          data?: QueryParamData,
        ): Promise<void> => {
          await router.push({
            pathname: paths.extensionsPageAppletProvider,
            query: {
              manifestId,
              ...(name !== undefined ? { name } : {}),
              ...(data !== undefined ? { data: JSON.stringify(data) } : {}),
            },
          });
        },
      ),
      pageApplet.onClose(navigate),
    ];

    return () => {
      for (const unsubscribe of unsubscribes) {
        unsubscribe();
      }
    };
  }, []);
}
